<template lang="pug">
b-modal#editThemeContent(
  ref="editThemeContent"
  :title="$t('ui.combine.edit_theme_content')"
  centered
  no-fade
  no-close-on-backdrop
  :busy="loading"
  @ok="done"
  @show="reset"
  @shown="shown")
  b-form(novalidate :disabled="!feedback.success" @submit.stop.prevent="submit")
    b-form-group(:label="$t('ui.content_id')" disabled).mb-1
      DebounceInput(
        size="sm"
        ref="content_id"
        required
        type="text"
        v-model="content_id"
        :disabled="loading"
      )
    b-form-group(:label="$t('ui.content_desc')").mb-1
      DebounceInput(
        size="sm"
        ref="content_desc"
        type="text"
        :dirty="$v.content_desc.$dirty"
        :error="$v.content_desc.$error"
        v-model.trim.lazy="$v.content_desc.$model"
        :disabled="loading"
      )
      ValidateResult(:value="$v.content_desc" :name="$t('ui.content_desc')")
    b-form-group(:label="$t('ui.sequence')").mb-1
      DebounceInput(
        size="sm"
        ref="sequence"
        required
        type="number"
        :min="min"
        :max="max"
        :dirty="$v.sequence.$dirty"
        :error="$v.sequence.$error"
        v-model.trim.lazy="$v.sequence.$model"
        :disabled="loading"
      )
      ValidateResult(:value="$v.sequence" :name="$t('ui.sequence')")
    .row
      .col
        b-alert.animated.flash(:show="!feedback.success" variant="bottom") {{ $t("error." + feedback.status) }}
  div(slot="modal-cancel")
    SubmitButton(:loading="loading" icon="fa fa-times" :text="$t('ui.close')" isModal=true)
  div(slot="modal-ok")
    SubmitButton(:loading="loading" icon="fa fa-save" :text="$t('ui.save')" isModal=true)
</template>

<script>
import { required, minValue, maxValue, minLength, maxLength } from "vuelidate/lib/validators";
import config from "@/config";
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton";
import ValidateResult from "@/library/ValidateResult";
import DebounceInput from "@/library/DebounceInput";

export default {
  components: {
    SubmitButton,
    ValidateResult,
    DebounceInput
  },
  props: {
    item: {
      type: Object
    }
  },
  data() {
    return {
      content_id: "",
      content_desc: "",
      sequence: "",
      min: 1,
      max: 999999999,
      loading: false,
      feedback: {
        success: true,
        status: ""
      }
    };
  },
  validations: {
    content_desc: {
      // required,
      minLength: minLength(2),
      maxLength: maxLength(200)
    },
    sequence: {
      required,
      minValue: minValue(0),
      maxValue: maxValue(999999999)
      // minLength: minLength(3),
      // maxLength: maxLength(50)
    }
  },
  methods: {
    done(evt) {
      evt.preventDefault();
      this.submit();
    },
    submit() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        let url = config.editContentUrl();
        var json = {
          auth_token: this.$store.getters.sessionToken,
          action_by: this.$store.getters.loginId,
          content_id: this.content_id,
          content_desc: this.content_desc,
          sequence: this.sequence
        };
        this.loading = true;

        this.$http.post(url, json).then(
          function(response) {
            this.loading = false;
            // Success
            try {
              if (response) {
                this.feedback.success = (typeof response.data.status == "string") ? response.data.status == "1" : response.data.status == 1;

                this.feedback.status = response.data.statusdesc;
                if (this.feedback.success == true) {
                  this.$emit("clicked");
                } else {
                  this.$helpers.handleFeedback(this.feedback.status);
                  this.$emit("failed", "edit_theme_content", this.feedback.status);
                }
                this.$nextTick(() => {
                  this.$refs.editThemeContent.hide();
                });
              }
            } catch (error) {
              this.loading = false;
              if (error.status.toLowerCase() == "nochanges") {
                this.$emit("clicked");
                this.$nextTick(() => {
                  this.$refs.editThemeContent.hide();
                });
              } else {
                this.feedback.success = false;
                this.feedback.status = error.status;
                this.$helpers.handleFeedback(this.feedback.status);
              }
            }
          },
          function(response) {
            this.loading = false;
            // Error
            this.feedback.success = false;
            this.feedback.status = response.data.status;
            this.$helpers.handleFeedback(this.feedback.status);
          }
        );
      }
    },
    reset() {
      this.content_id = "";
      this.content_desc = ";"
      this.sequence = "";
      this.feedback.success = true;
      this.feedback.status = "";
    },
    shown() {
      this.$v.$reset();
      this.content_id = this.item.content_id;
      this.content_desc = this.item.content_desc;
      this.sequence = this.item.sequence;
      this.$refs.content_desc.$el.focus();
    }
  }
};
</script>
